import { ComponentType } from 'react';
import {
  Audit,
  AuditQueue,
  Courses,
  EnhancedAudit,
  Exams,
  ExamSessions,
  IncompleteAudits,
  LogIn,
  NeedsReview,
  Partners,
  Review,
  TargetReport,
  Verification,
} from '../../pages';
import { generatePath, Params, useNavigate, useParams } from 'react-router-dom';
import { any } from 'ramda';
import { RouteEnum } from './interfaces';

export interface RouteConfig {
  label: string;
  path: string;
  component: ComponentType;
  index?: boolean;
  authenticated: boolean;
}

export type MyParams = {
  partner: string;
  course: string;
  exam: string;
  session: string;
  audit: string;
};
export const routes: Record<RouteEnum, RouteConfig> = {
  [RouteEnum.Login]: {
    label: 'Sign In',
    path: RouteEnum.Login,
    component: LogIn,
    authenticated: false,
  },
  [RouteEnum.Verification]: {
    label: 'Verification',
    path: RouteEnum.Verification,
    component: Verification,
    authenticated: false,
  },
  [RouteEnum.Partners]: {
    label: 'Partners',
    path: RouteEnum.Partners,
    component: Partners,
    authenticated: true,
  },
  [RouteEnum.Courses]: {
    label: 'Courses',
    path: RouteEnum.Courses,
    component: Courses,
    authenticated: true,
  },
  [RouteEnum.Exams]: {
    label: 'Exams',
    path: RouteEnum.Exams,
    component: Exams,
    authenticated: true,
  },
  [RouteEnum.ExamSessions]: {
    label: 'Exam Sessions',
    path: RouteEnum.ExamSessions,
    component: ExamSessions,
    authenticated: true,
  },
  [RouteEnum.ExamAudit]: {
    label: 'Exam Audit',
    path: RouteEnum.ExamAudit,
    component: Audit,
    authenticated: true,
  },
  [RouteEnum.AuditQueue]: {
    label: 'Audit Queue',
    path: RouteEnum.AuditQueue,
    component: AuditQueue,
    authenticated: true,
  },
  [RouteEnum.EnhancedAudit]: {
    label: 'Exam Audit Review',
    path: RouteEnum.EnhancedAudit,
    component: EnhancedAudit,
    authenticated: true,
  },
  [RouteEnum.NeedsReview]: {
    label: 'Needs Review',
    path: RouteEnum.NeedsReview,
    component: NeedsReview,
    authenticated: true,
  },
  [RouteEnum.Review]: {
    label: 'Exam Audit Review',
    path: RouteEnum.Review,
    component: Review,
    authenticated: true,
  },
  [RouteEnum.TargetReport]: {
    label: 'Target Report',
    path: RouteEnum.TargetReport,
    component: TargetReport,
    authenticated: true,
  },
  [RouteEnum.IncompleteAudits]: {
    label: 'Incomplete Audits',
    path: RouteEnum.IncompleteAudits,
    component: IncompleteAudits,
    authenticated: true,
  },
};
export const authenticatedRoutes: RouteConfig[] = [];
export const unauthenticatedRoutes: RouteConfig[] = [];
Object.values(routes).forEach((route) => {
  const dest = route.authenticated ? authenticatedRoutes : unauthenticatedRoutes;
  dest.push(route);
});

export function useGotoRoute(name: RouteEnum): (params?: Params<string>) => void {
  const navigate = useNavigate();
  const previousParams = useParams();
  const route = routes[name];

  return function gotoRoute(newParams) {
    const params = Object.assign(previousParams, newParams);
    const path = generatePath(route.path, params);
    navigate(path);
  };
}

export function generateRoutePath({
  name,
  params,
}: {
  name: RouteEnum;
  params?: Params<string>;
}): RouteEnum {
  const route = routes[name];

  return generatePath(`${route.path}`, params) as RouteEnum;
}

export const isCurrentLocation = (location: string): boolean => {
  return window.location.pathname === location;
};
export const isCurrentLocationOneOf = (locations: string[]): boolean => {
  return any((location: string) => isCurrentLocation(location))(locations);
};
